module.exports = __webpack_public_path__ + "img/材料力学5_12_4.0abc1633.jpg";